module.exports = {"ENV":{"REQUEST_TIMEOUT":"1500","mode":"dev","HOST":"https://mobileself.net","PORT":"","VERSION":"v1","BASE_URL":"/demo/api/public/index.php/","SURVEY_LINK_ENABLED":false,"LANGUAGE_LINK_ENABLED":false,"STAFF_CALL_LINK_ENABLED":true},"HOST":{"product":"https://mobileself.net","dev":"https://dev.mobileself.net"},"dialog":{"optionError":{"title":"Mobileself Message","class":"toast_error"}},"languages":[{"label":"ENGLISH","lang":"en"},{"label":"日本語","lang":"ja"},{"label":"中　文","lang":"ch"}],"CSS_BASE":"katsugen"}


//////////////////
// WEBPACK FOOTER
// ./src/ms.config.json
// module id = imvn
// module chunks = 1